<template>
  <div>
    <b-container class="mt-10">
      <b-row>
        <b-col sm class="text-center">
          <img alt="Logo" src="../../assets/logo.png" class="h-150px my-9" />
        </b-col>
      </b-row>
    </b-container>
    <div class="container card_container p-10 p-lg-5 mx-auto phone">
      <b-container class="bv-example-row">
        <b-row>
          <b-col sm class="mx-auto">
            <h4 class="text-center mb-5 mt-5">ACCEDI</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm class="mb-5">
            <strong>username</strong>
            <input class="form-control form-control-sm" type="text" name="user" required v-on:keyup.enter="onAccedi" v-model="loginData.username" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>Password</strong>
            <VuePassword v-model="loginData.password" id="password1" :disableStrength="true" v-on:keyup.enter="onAccedi" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm class="mb-5 text-center">
            <a>
              <b-button variant="primary" size="lg" class="w-100" @click="onAccedi" style="margin-top: 20px"> Accedi </b-button>
            </a>
          </b-col>
        </b-row>
      </b-container>
      <modal-recuper-password></modal-recuper-password>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#00388C" loader="dots" :height="120" :width="120"></loading>
  </div>
</template>
<script>
import router from "../../router/router";
import VuePassword from "vue-password";
import ModalRecuperPassword from "../modal/modalRecuperPassword.vue";
import Loading from "vue-loading-overlay";
import Operatore from '@/services/operatore/Operatore';

export default {
  components: {ModalRecuperPassword, VuePassword, Loading },
  data() {
    return {
      data: {},
      loginData: {
        username: null,
        password: null,
      },
      isLoading: false,
      boolTermini: false,
      terminiServizio: false
    };
  },
  mounted: function () {

  },
  methods: {
    onAccedi() {
      let me = this;
      if (!me.loginData.username || !me.loginData.password) {
        return me.$bvModal
          .msgBoxOk("Inserisci username e password", {
            title: "Errore Login",
            size: "sm",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "Chiudi",
          })
          .then()
          .catch();
      }
      me.isLoading = true;
      Operatore.login(process.env.VUE_APP_CODICE_STRUTTURA, me.loginData)
        .then(response => {
          if (response.data.error) {
            this.$bvModal.msgBoxOk(response.data.msg, {
              title: "Errore Login",
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
              okTitle: "Chiudi",
            })
              .then()
              .catch();
          } else {
            sessionStorage.setItem("loginData", response.data.data.token);
            router.push({
              name: "Agenda",
            });
          }
        })
        .catch()
        .finally(() => me.isLoading = false);
    },
  },
};
</script>
<style>

.frameTermini{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
